import dayjs from 'dayjs';
import isToday from 'dayjs/plugin/isToday';

dayjs.extend(isToday);

export function formatTimeLength(time) {
  const num_10 = 10;
  const num_13 = 13;
  const timeLength = time.toString().length;
  if (timeLength === num_10) {
    return dayjs.unix(time);
  } else if (timeLength === num_13) {
    return dayjs(time);
  } else {
    throw Error('不合法时间戳');
  }
}

export function formatTime(time) {
  const t = formatTimeLength(time);
  if (t.isToday()) {
    return t.format('HH:mm');
  } else if (dayjs().year() === t.year()) {
    return t.format('MM-DD HH:mm');
  } else {
    return t.format('YYYY-MM-DD HH:mm');
  }
}
